import {Component, ElementRef, inject, input} from '@angular/core';
import {ButtonComponent} from '../../shared/button/button.component';
import {NavigateService} from '../../../services/navigate.service';

@Component({
  selector: 'app-key-expiration-toast',
  imports: [
    ButtonComponent
  ],
  templateUrl: './key-expiration-toast.component.html',
  host: { class: 'app-column-auto gapped centered-items' }
})
export class KeyExpirationToastComponent {
  readonly expirationDays = input.required<number>()
  private readonly navigate = inject(NavigateService)
  private elementRef = inject(ElementRef)

  protected manageKeys() {
    this.navigate.profile()
    this.elementRef.nativeElement.dispatchEvent(new CustomEvent('closeToast', {bubbles: true}))
  }
}
